import "./style.css"
import * as THREE from "three"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"
import { SVGLoader } from "three/examples/jsm/loaders/SVGLoader"
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter"
import * as dat from "dat.gui"

// Set up dat.GUI
const gui = new dat.GUI({ autoPlace: false })
gui.domElement.id = "gui"
const guiContainer = document.getElementById("gui_container")
guiContainer.appendChild(gui.domElement)

const parameters = {}
parameters.xScale = 0.1
parameters.yScale = 0.1
parameters.zScale = 0.1

const importSVGFolder = gui.addFolder("Import SVG")
importSVGFolder.open()

// Canvas
const canvas = document.querySelector("canvas.webgl")

// Scene
const scene = new THREE.Scene()
parameters.sceneBackgroundColor = "#F8F8F8"
scene.background = new THREE.Color(parameters.sceneBackgroundColor)

const sceneFolder = gui.addFolder("Scene settings")
sceneFolder.open()
sceneFolder
	.addColor(parameters, "sceneBackgroundColor")
	.name("Scene color")
	.onChange((value) => {
		scene.background.set(value)
	})

// enable option to cast shadows in dat gui
parameters.castShadow = false

// sceneFolder.add(parameters, "castShadow").name("Enable shadows")

// Lights
// TODO add three point lighting
// TODO adjust lights

const light = new THREE.AmbientLight(0x404040, 4)
light.castShadow = true
scene.add(light)

const directionalLight = new THREE.DirectionalLight("#ffffff", 2)
directionalLight.position.set(4, 5, -2)
const directionalLightFolder = gui.addFolder("Lighting")
directionalLightFolder.open()

// Size and settings parameters

const sizeSettingsFolder = gui.addFolder("Size and settings")

// const directionalLightSettings = {
// 	intensity: directionalLight.intensity,
// }

directionalLightFolder
	.add(directionalLight, "intensity")
	.min(0)
	.max(10)
	.step(0.001)
directionalLightFolder
	.add(directionalLight.position, "x")
	.name("x position")
	.min(-25)
	.max(25)
	.step(0.001)
directionalLightFolder
	.add(directionalLight.position, "y")
	.name("y position")
	.min(-25)
	.max(25)
	.step(0.001)
directionalLightFolder
	.add(directionalLight.position, "z")
	.name("z position")
	.min(-25)
	.max(25)
	.step(0.001)
scene.add(directionalLight)

const directionalLightHelper = new THREE.DirectionalLightHelper(
	directionalLight
)
// scene.add(directionalLightHelper)

/**
 * Sizes
 */
const sizes = {
	width: window.innerWidth,
	height: window.innerHeight,
}

window.addEventListener("resize", () => {
	// Update sizes
	sizes.width = window.innerWidth
	sizes.height = window.innerHeight

	// Update camera
	camera.aspect = sizes.width / sizes.height
	camera.updateProjectionMatrix()

	// Update renderer
	renderer.setSize(sizes.width, sizes.height)
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
	75,
	sizes.width / sizes.height,
	0.1,
	500
)

camera.position.x = 40
camera.position.y = 40
camera.position.z = 40
scene.add(camera)

const camera2 = new THREE.PerspectiveCamera(
	75,
	sizes.width / sizes.height,
	0.1,
	500
)

scene.add(camera2)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = false
controls.minDistance = 30
controls.maxDistance = 300

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
	canvas: canvas,
	antialias: true,
	preserveDrawingBuffer: true,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// import the SVG file
const loader = new SVGLoader()
let svgMarkup = document.querySelector("svg").outerHTML
let svgData = loader.parse(svgMarkup)

// clear the scene
// reference - https://stackoverflow.com/questions/30359830/how-do-i-clear-three-js-scene
function clearThree(obj, centerBox) {
	while (obj.children.length > 0) {
		clearThree(obj.children[0])
		obj.remove(obj.children[0])
	}
	if (obj.geometry) obj.geometry.dispose()

	if (obj.material) {
		Object.keys(obj.material).forEach((prop) => {
			if (!obj.material[prop]) return
			if (
				obj.material[prop] !== null &&
				typeof obj.material[prop].dispose === "function"
			)
				obj.material[prop].dispose()
		})
		obj.material.dispose()
	}
}
// group containing paths
let svgGroup = new THREE.Group()

function createSVGGroup(svgData) {
	let box, center, sizeVec3, size, scaleVec, scale, centerBox

	// destroy old group
	if (svgGroup) {
		clearThree(svgGroup, centerBox)
		scene.remove(svgGroup)
		svgGroup = new THREE.Group()
		box = ""
		center = ""
		sizeVec3 = ""
		size = ""
		scaleVec = ""
		scale = ""
		centerBox = ""
	}

	// loop through parsed paths
	svgData.paths.forEach((path) => {
		const shapes = path.toShapes(true)

		shapes.forEach((shape) => {
			const geometryDepth = 40

			const geometry = new THREE.ExtrudeBufferGeometry(shape, {
				depth: geometryDepth,
				// bevelEnabled: true,
				// bevelThickness: 5,
				// bevelSegments: 5,
			})

			// add gui for depth settings

			// create a mesh and add it to the group
			const material = new THREE.MeshStandardMaterial({
				color: path.color,
				depthWrite: true,
				// side: THREE.DoubleSide,
				// wireframe: true,
			})
			const mesh = new THREE.Mesh(geometry, material)

			// get the size of the mesh
			// TODO: resize the whole group instead of the individual meshes
			// TODO: resize based on initial size of the svg
			box = new THREE.Box3().setFromObject(mesh)
			center = new THREE.Vector3()
			sizeVec3 = box.getSize(center)
			size = sizeVec3.x + sizeVec3.y + sizeVec3.z
			scaleVec = new THREE.Vector3(3, 3, 3).divide(sizeVec3)
			scale = Math.max(scaleVec.x, scaleVec.y, scaleVec.z)

			// get the radius of the mesh
			// mesh.geometry.computeBoundingSphere()
			// const radius = mesh.geometry.boundingSphere.radius

			// change z value of mesh based on radius
			// TODO: use depthMultiplier instead of hardcoded value
			mesh.position.z += size * 0.01
			// console.log(mesh.position.z)
			// change z size of mesh based on radius
			// mesh.scale.z += 1 / radius

			// resize svgGroup
			svgGroup.scale.setScalar(scale)
			svgGroup.scale.x = parameters.xScale
			svgGroup.scale.y = parameters.yScale
			svgGroup.scale.z = parameters.zScale

			svgGroup.castShadow = true
			svgGroup.add(mesh)
		})
	})

	// invert on y axis
	svgGroup.scale.y *= -1

	// center the svgGroup
	centerBox = new THREE.Box3()
		.setFromObject(svgGroup)
		.getCenter(svgGroup.position)
		.multiplyScalar(-1)

	scene.add(svgGroup)
}

createSVGGroup(svgData)

// Add option to import an SVG locally or from a URL

const svgContainer = document.getElementById("svg-input")

let file = ""
const uploadConfig = function () {
	// this["Import from URL"] = () => {
	// 	const url = prompt("Enter URL")
	// 	if (url) {
	// 		fetch(url)
	// 			.then((res) => res.text())
	// 			.then((svg) => {
	// 				svgContainer.innerHTML = svg
	// 				svgMarkup = svgContainer.outerHTML
	// 				svgData = loader.parse(svgMarkup)
	// 				createSVGGroup(svgData)
	// 			})
	// 	}
	// }

	this["Upload SVG file"] = () => {
		const input = document.getElementById("file-path")
		input.addEventListener("change", () => {
			file = input.files[0]

			const reader = new FileReader()
			reader.onload = function (e) {
				svgMarkup = e.target.result
				svgData = loader.parse(svgMarkup)
				createSVGGroup(svgData)
			}
			reader.readAsText(file)
		})
		input.click()
	}
}

const config = new uploadConfig()
importSVGFolder.add(config, "Upload SVG file")
// importSVGFolder.add(config, "Import from URL")

sizeSettingsFolder.open()
sizeSettingsFolder
	.add(parameters, "zScale")
	.min(0.05)
	.max(0.5)
	.step(0.001)
	.name("depth")
	.onChange(() => createSVGGroup(svgData))

sizeSettingsFolder
	.add(parameters, "xScale")
	.min(0.05)
	.max(0.5)
	.step(0.001)
	.name("width")
	.onChange(() => createSVGGroup(svgData))

sizeSettingsFolder
	.add(parameters, "yScale")
	.min(0.05)
	.max(0.5)
	.step(0.001)
	.name("height")
	.onChange(() => createSVGGroup(svgData))

// Export as gltf

const exportFolder = gui.addFolder("Export")

const gltfLink = document.createElement("a")
gltfLink.style.display = "none"
document.body.appendChild(gltfLink)

function save(blob, filename) {
	gltfLink.href = URL.createObjectURL(blob)
	gltfLink.download = filename
	gltfLink.click()
}

function saveArrayBuffer(buffer, filename) {
	save(new Blob([buffer], { type: "application/octet-stream" }), filename)
}

function saveString(text, filename) {
	save(new Blob([text], { type: "text/plain" }), filename)
}

function exportGLTF(input) {
	const gltfExporter = new GLTFExporter()

	gltfExporter.parse(
		input,
		function (result) {
			if (result instanceof ArrayBuffer) {
				saveArrayBuffer(result, "scene.glb")
			} else {
				const output = JSON.stringify(result, null, 2)
				saveString(output, "scene.gltf")
			}
		},
		function (error) {
			console.log("An error happened during parsing", error)
		}
	)
}

parameters.exportAsGLTF = () => {
	exportGLTF(svgGroup)
}

parameters.exportAsPng = (scene) => {
	let imgData = renderer.domElement.toDataURL("image/png")
	const link = document.createElement("a")
	link.download = "scene.png"
	link.href = imgData
	link.click()
}

exportFolder.open()
exportFolder.add(parameters, "exportAsGLTF").name("Export as GLTF")
exportFolder.add(parameters, "exportAsPng").name("Export as PNG")

/**
 * Animate
 */

const clock = new THREE.Clock()

const tick = () => {
	const elapsedTime = clock.getElapsedTime()

	// Update objects
	// sphere.rotation.y = 0.5 * elapsedTime

	// Update Orbital Controls
	controls.update()

	// Render
	renderer.render(scene, camera)

	// Call tick again on the next frame
	window.requestAnimationFrame(tick)
}

tick()
